/* @ngInject */

export default ($mdUtil, $timeout) => {
  const validate = (ctrl, scope) => {
    scope.stPhoneValidationMessage = '';
    ctrl.$setValidity('isValid', true);
  };
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      stPhonePrefix: '@',
      stPhoneRegion: '@',
      stPhoneValidationMessage: '='
    },
    link: (scope, element, attrs, ctrl) => {
      $timeout(() => {
        // validate(ctrl, scope, attrs.stPhonePrefix, ctrl.$modelValue, attrs.stPhoneRegion);
        element.bind(
          'keydown keypress',
          $mdUtil.debounce(
            () =>
              validate(ctrl, scope, attrs.stPhonePrefix, ctrl.$modelValue, attrs.stPhoneRegion),
            1500
          )
        );
      });
    }
  };
};
